module.exports = __webpack_public_path__ + "static/media/bg1.a18e3f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg1.jpg
// module id = 583
// module chunks = 0